import { componentService } from './component-service';

/**
 * @typedef {Object} ComponentTrackingObject with Submodules
 * @property {Object} attributes
 * @property {number} attributes.moduleNumber
 * @property {number} attributes.subNumber
 */
class ComponentObjectSubModule {
	/**
	 * registers to ComponentService
	 * @constructor singleton
	 */
	constructor() {
		if (ComponentObjectSubModule._instance) {
			return ComponentObjectSubModule._instance;
		}

		componentService.register(ComponentObjectSubModule.getData);

		ComponentObjectSubModule._instance = this;
	}

	/**
	 * Retrieves subModule tracking data
	 * @param {HTMLElement} element_ - the component element
	 * @param {number} index_ - the index of element_ in its NodeList
	 * @returns {Promise<Array<ComponentTrackingObject>>} - Promise that evaluates to subModule tracking data
	 */
	static async getData(element_, index_) {
		const res = [];

		if (element_ === null) {
			return res;
		}

		const subModules = element_.querySelectorAll('.audi-j-module-item');
		const subModulesLength = subModules.length;

		for (let i = 0; i < subModulesLength; i += 1) {
			res.push({
				componentInfo: {
					componentID: index_ + '-' + i,
				},
				attributes: {
					subNumber: i,
				},
			});
		}

		return res;
	}
}

/**
 * Singleton instance
 * @type {ComponentObjectSubModule}
 * @private
 * @static
 */

const componentObjectSubModule = new ComponentObjectSubModule();

export { componentObjectSubModule, ComponentObjectSubModule };
